import { useEffect, useState } from "react";
import { FormControlLabel, Radio, TextField, Typography } from "@mui/material";
import { addOpacityToHexColor } from "../../../utils/addOpacityToHexColor";

const TableSheetChoices = ({ selections, question, selectChoice, themeColors, pageIndex, rowsPerPage }) => {
    const [headers, setHeaders] = useState([]);

    useEffect(() => {
        setHeaders(Object.values(question.choices.headers));
    }, [question.choices.headers]);

    function choicesData() {
        if (question && question.choices && question.choices.data) {
            return question.choices.data.slice(pageIndex * rowsPerPage, rowsPerPage + pageIndex * rowsPerPage);
        }
        return [];
    }

    return (
        <>
            <fieldset className="relative">
                <legend className="hidden">Primary Goals</legend>
                <table className="rounded-t-md overflow-hidden w-full">
                    <thead
                        style={{
                            backgroundColor: themeColors.primaryColor,
                        }}
                        className="text-white"
                    >
                        <tr className="space-x-5">
                            {headers.map((header, index) => (
                                <th
                                    key={`table-header-${index}`}
                                    className={`p-4 w-[150px]${index === 0 ? " md:w-[300px] xl:w-[400px] text-left" : ""}`}
                                >
                                    <Typography
                                        sx={{
                                            color: "#F9FAFB",
                                            fontSize: "12px",
                                            fontWeight: 600,
                                            letterSpacing: "-0.2px",
                                            lineHeight: "20px",
                                        }}
                                    >
                                        {header}
                                    </Typography>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {choicesData().map((choice, index) => (
                            <tr
                                key={index}
                                style={{
                                    backgroundColor:
                                        index % 2 == 1 ? addOpacityToHexColor(themeColors.secondaryColor, 0.1) : "",
                                }}
                                className="border-x-slate-100 border-x border-b-slate-100 border-b"
                            >
                                <td className="p-4 text-xs md:text-base text-[#5E718D]">
                                    {/* todo determine if this font size/weight is used anywhere else */}
                                    <Typography
                                        sx={{
                                            color: "#5E718D",
                                            fontSize: 14,
                                            fontWeight: 600,
                                            letterSpacing: "-0.2px",
                                            lineHeight: "24px",
                                        }}
                                    >
                                        {choice.label}
                                    </Typography>

                                    {JSON.stringify(choice).includes("with_textbox") ? (
                                        <TextField
                                            slotProps={{
                                                htmlInput: {
                                                    "aria-label": choice.label
                                                }
                                            }}
                                            variant="outlined"
                                            size="small"
                                            value={
                                                selections &&
                                                selections[question.id] &&
                                                selections[question.id][choice.id + "_textbox"] &&
                                                selections[question.id][choice.id + "_textbox"].answer
                                            }
                                            onChange={(e) =>
                                                selectChoice(
                                                    {
                                                        id: choice.id + "_textbox",
                                                        textbox: true,
                                                        answer: e.target.value,
                                                    },
                                                    question.id,
                                                )
                                            }
                                        ></TextField>
                                    ) : (
                                        ""
                                    )}
                                </td>

                                <td className="text-center py-3 text-sm">
                                    <FormControlLabel
                                        aria-label={`${choice.label} ${headers[1]}`}
                                        name={choice.label}
                                        className="margin-0"
                                        value="col2"
                                        checked={
                                            selections && selections[question.id]
                                                ? selections[question.id][choice.id]
                                                    ? selections[question.id][choice.id].answer === "col2"
                                                    : false
                                                : false
                                        }
                                        control={
                                            <Radio
                                                style={{
                                                    color: themeColors.primaryColor,
                                                }}
                                                onClick={() =>
                                                    selectChoice(
                                                        {
                                                            id: choice.id,
                                                            answer: "col2",
                                                            label: choice.label,
                                                            value: choice.value,
                                                        },
                                                        question.id,
                                                    )
                                                }
                                                name={choice.label}
                                            />
                                        }
                                    />
                                </td>
                                <td className="text-center py-3 text-sm">
                                    <FormControlLabel
                                        aria-label={`${choice.label} ${headers[2]}`}
                                        name={choice.label}
                                        className="margin-0"
                                        value="col3"
                                        checked={
                                            selections && selections[question.id]
                                                ? selections[question.id][choice.id]
                                                    ? selections[question.id][choice.id].answer === "col3"
                                                    : false
                                                : false
                                        }
                                        control={
                                            <Radio
                                                style={{
                                                    color: themeColors.primaryColor,
                                                }}
                                                onClick={() =>
                                                    selectChoice(
                                                        {
                                                            id: choice.id,
                                                            answer: "col3",
                                                            label: choice.label,
                                                            value: choice.value,
                                                        },
                                                        question.id,
                                                    )
                                                }
                                                name={choice.label}
                                            />
                                        }
                                    />
                                </td>
                                <td className="text-center py-3 text-sm">
                                    <FormControlLabel
                                        aria-label={`${choice.label} ${headers[3]}`}
                                        name={choice.label}
                                        className="margin-0"
                                        value="col4"
                                        checked={
                                            selections && selections[question.id]
                                                ? selections[question.id][choice.id]
                                                    ? selections[question.id][choice.id].answer === "col4"
                                                    : false
                                                : false
                                        }
                                        control={
                                            <Radio
                                                style={{
                                                    color: themeColors.primaryColor,
                                                }}
                                                onClick={() =>
                                                    selectChoice(
                                                        {
                                                            id: choice.id,
                                                            answer: "col4",
                                                            label: choice.label,
                                                            value: choice.value,
                                                        },
                                                        question.id,
                                                    )
                                                }
                                                name={choice.label}
                                            />
                                        }
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </fieldset>
        </>
    );
};

export default TableSheetChoices;
